import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/productShadow.svg';

export const IconProductShadow = createIconComponent(Icon);
